/**
 * @voltxampere/ui — DS3231 I2C RTC variant (Sprint 48-7)
 *
 * Sprint 48-7 — Replaces Sprint 45-5 DS1307 placeholder with the
 * superior DS3231 (TCXO accuracy ±2 ppm, factory-trimmed, no external
 * crystal needed). I2C 7-bit slave at address 0x68. Pin-compatible
 * with DS1307 in DIP-8 / SOIC-16. Battery-backed real-time clock,
 * 32 KHz output, two time-of-day alarms.
 *
 * Sensor activation layer reads:
 *   - 0x00..0x06: seconds, minutes, hours, day, date, month, year (BCD)
 *   - 0x07..0x0E: alarm 1 / alarm 2 registers
 *   - 0x0F: status register (OSF flag)
 *   - 0x11..0x12: temperature sensor (signed 10-bit, 0.25°C resolution)
 *
 * Reference: Maxim/Analog Devices DS3231 datasheet (rev. F, 2015).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * for VCC rail drive (5V or 3.3V — both supported per datasheet).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorDs3231 = {
    id: "ds3231",
    nameTr: "DS3231 (I2C RTC, TCXO ±2ppm)",
    nameEn: "DS3231 (I2C RTC, TCXO ±2ppm)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "DS3231",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 3.3,
        // Sprint 48-7 — I2C activation metadata.
        i2cAddress: 0x68,
        i2cFrequency: 400_000, // DS3231 supports fast mode
        secondsRegister: 0x00,
        statusRegister: 0x0f,
        temperatureRegister: 0x11,
        has32kHzOutput: true,
        hasTwoAlarms: true,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-ds3231.js.map